import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/notifications.json';
import ar from './i18n/ar/notifications.json';

// Namespace is plain `notifications` (not feature-prefixed): the shared shell
// drawer in `@saas-kit/ui` also reads its copy from this namespace.
registerFeatureI18n('notifications', { en, ar });

export { NotificationsPage } from './NotificationsPage';
